import { Skeleton } from '../../../Skeleton'

import * as styles from './UserProfileHeaderFooterSkeleton.module.css'

function UserProfileHeaderFooterSkeleton() {
  return (
    <div className={styles.footer}>
      <Skeleton className={styles.skeletonButton} />
      <Skeleton className={styles.skeletonButton} />
    </div>
  )
}

export default UserProfileHeaderFooterSkeleton
